// Sample employee files data structure
export const employeeFiles = [
  {
    id: "employee-handbook-2026",
    name: "Employee Handbook 2026.pdf",
    fileUrl: "/employee-files/employee-handbook-2026.pdf",
    type: "PDF",
    category: "Policies",
    department: "Human Resources",
    uploadedAt: "2026-09-01",
    updatedAt: "2026-09-05",
    size: "2.4 MB",
    description: "Current employee policies and workplace guidelines.",
    keywords: ["Employee", "Handbook", "Policies", "HR"]
  },
  {
    id: "payroll-form-2026",
    name: "Payroll Information Form.pdf",
    fileUrl: "/employee-files/payroll-form-2026.pdf",
    type: "PDF",
    category: "Employee Forms",
    department: "Human Resources",
    uploadedAt: "2026-08-15",
    updatedAt: "2026-08-15",
    size: "156 KB",
    description: "Direct deposit and tax withholding form.",
    keywords: ["Payroll", "Form", "Direct Deposit", "Tax"]
  },
  {
    id: "safety-manual-2026",
    name: "Rail Safety Manual 2026.pdf",
    fileUrl: "/employee-files/safety-manual-2026.pdf",
    type: "PDF",
    category: "Safety",
    department: "Safety",
    uploadedAt: "2026-07-20",
    updatedAt: "2026-09-10",
    size: "5.8 MB",
    description: "Comprehensive safety procedures and protocols for rail operations.",
    keywords: ["Safety", "Manual", "Rail", "Procedures", "Operations"]
  },
  {
    id: "benefits-overview-2026",
    name: "Benefits Overview 2026.pdf",
    fileUrl: "/employee-files/benefits-overview-2026.pdf",
    type: "PDF",
    category: "Benefits",
    department: "Human Resources",
    uploadedAt: "2026-01-05",
    updatedAt: "2026-01-05",
    size: "1.2 MB",
    description: "Health insurance, retirement plans, and employee benefits information.",
    keywords: ["Benefits", "Health", "Insurance", "Retirement", "401k"]
  },
  {
    id: "org-chart-2026",
    name: "Organization Chart 2026.xlsx",
    fileUrl: "/employee-files/org-chart-2026.xlsx",
    type: "Excel",
    category: "Corporate Documents",
    department: "Corporate",
    uploadedAt: "2026-06-01",
    updatedAt: "2026-09-01",
    size: "234 KB",
    description: "Current organizational structure and reporting relationships.",
    keywords: ["Organization", "Chart", "Structure", "Reporting"]
  },
  {
    id: "time-off-request-form",
    name: "Time Off Request Form.docx",
    fileUrl: "/employee-files/time-off-request-form.docx",
    type: "Word",
    category: "Employee Forms",
    department: "Human Resources",
    uploadedAt: "2026-01-10",
    updatedAt: "2026-01-10",
    size: "45 KB",
    description: "Form for requesting vacation, sick leave, or personal days.",
    keywords: ["Time Off", "Vacation", "Leave", "Request", "Form"]
  },
  {
    id: "it-support-guide",
    name: "IT Support Guide.pdf",
    fileUrl: "/employee-files/it-support-guide.pdf",
    type: "PDF",
    category: "IT",
    department: "Information Technology",
    uploadedAt: "2026-03-15",
    updatedAt: "2026-08-20",
    size: "890 KB",
    description: "Troubleshooting guide and IT support contact information.",
    keywords: ["IT", "Support", "Technology", "Help", "Troubleshooting"]
  },
  {
    id: "training-schedule-q4",
    name: "Training Schedule Q4 2026.xlsx",
    fileUrl: "/employee-files/training-schedule-q4.xlsx",
    type: "Excel",
    category: "Training",
    department: "Operations",
    uploadedAt: "2026-09-01",
    updatedAt: "2026-09-15",
    size: "178 KB",
    description: "Fourth quarter training sessions and registration information.",
    keywords: ["Training", "Schedule", "Q4", "Sessions", "Registration"]
  }
];

// Filter options
export const fileTypes = ["All", "PDF", "Word", "Excel", "CSV", "Text", "Images", "ZIP", "Other"];

export const categories = [
  "All",
  "Employee Forms",
  "Policies",
  "HR",
  "Payroll",
  "Benefits",
  "Safety",
  "Training",
  "Operations",
  "Corporate Documents",
  "Reference Material",
  "Manuals",
  "IT",
  "Other"
];

export const departments = [
  "All",
  "Corporate",
  "Human Resources",
  "Operations",
  "Finance",
  "Administration",
  "Safety",
  "Information Technology",
  "Management",
  "Other"
];

export const sortOptions = [
  { value: "name-asc", label: "File Name (A-Z)" },
  { value: "name-desc", label: "File Name (Z-A)" },
  { value: "newest", label: "Newest Uploaded" },
  { value: "oldest", label: "Oldest Uploaded" },
  { value: "updated", label: "Recently Updated" },
  { value: "size", label: "File Size" },
  { value: "type", label: "File Type" },
  { value: "category", label: "Category" }
];
